import { createStyles, makeStyles } from '@material-ui/core'
import React, { ReactElement } from 'react'
import { DefaultComponentProps } from '@material-ui/core/OverridableComponent'
import ButtonWithProgress from '../../../common/ButtonWithProgress'

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      margin: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        margin: 4,
        flexBasis: '45%'
      }
    },
    btn: {
      minWidth: 80,
      fontSize: '70%',
      [theme.breakpoints.down('sm')]: {
        minWidth: '100%',
        minHeight: '40px',
        background: theme.palette.background.default,
        color: theme.palette.text.primary,
      }
    }
  })
)
interface Props extends DefaultComponentProps<any> {
  children: string
  loading?: boolean
  disabled?: boolean
}

export default function DetailViewBtnManipulation({
  children,
  loading,
  ...props
}: Props): ReactElement {
  const classes = useStyles({} as Props)
  return (
    <div className={classes.root}>
      <ButtonWithProgress
        variant='contained'
        color={props.disabled ? 'inherit' : 'primary'}
        onClick={props.onClick}
        loading={props.loading}
        className={classes.btn}
      >
        {children}
      </ButtonWithProgress>
    </div>
  )
}
